export default "__VITE_ASSET__Dvhnx3r4__"